/**
 * Handoff codes are short-lived JWTs from `/auth/handoff/create` (PyJWT).
 * Validate shape before using query-derived values in fetch URLs (Sonar S8476).
 */
/** Base64url segment with optional padding (0–2 '='), per JWT/JWS encoding. */
const JWT_SEGMENT = /^[A-Za-z0-9_-]+={0,2}$/

/** Upper bound avoids huge malicious `_handoff` values; real tokens are far smaller. */
const HANDOFF_MAX_LENGTH = 524_288

export function isValidHandoffCodeShape(code: string): boolean {
  if (code.length < 20 || code.length > HANDOFF_MAX_LENGTH) {
    return false
  }
  const parts = code.split('.')
  if (parts.length !== 3) {
    return false
  }
  return parts.every((part) => part.length > 0 && JWT_SEGMENT.test(part))
}
